<template>
  <div class="recommend-wrapper">
    <div class="title">
      <div class="attention-title"><img src="/Application/Home/Resource/mini-program-static/new-teacher-title.png"></div>
      <div class="sub-title"><span>老师主带名额有限，要抓紧时间哟</span></div>
    </div>
    <div class="teacher-list" v-if="dataDone">
      <div class="flowing-star1"><img src="/Application/Home/Resource/mini-program-static/flowing-star2.png"></div>
      <div class="flowing-star2"><img src="/Application/Home/Resource/mini-program-static/flowing-star1.png"></div>
      <div class="teacher-item" v-for="item in teacherList" :key="item.id" @click="toTeacherDetail(item.id)">
        <div class="avatar lazy-load"><img :src="item.avatar"></div>
        <div class="info">
          <div class="name">{{item.stagename}}</div>
          <div class="title-box">
            <div class="teacher-title">{{item.title1}}</div>
            <div class="teacher-title">{{item.title2}}</div>
          </div>
        </div>
        <icon icon-class="arrow-right" class="link-arrow"></icon>
      </div>
    </div>
    <div class="bottom-view"></div>
  </div>
</template>

<style lang="less" scoped>
  .recommend-wrapper{
    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-height: 100vh;
    background: linear-gradient(180deg,rgba(108,144,244,1) 0%,rgba(58,87,229,1) 100%);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: top left;
    padding: 0 15px;
    padding-bottom: 1px;
    overflow-x: hidden;
    &::before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 2.2rem;
      background: url('/Application/Home/Resource/static/images/mobile/recommend-bg-top.png');
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: top left;
    }
    &::after{
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 3.7rem;
      background: url('/Application/Home/Resource/static/images/mobile/recommend-bg-bottom.png');
      background-size: 100%;
      background-repeat: no-repeat;
      background-position: top left;
    }
    .title{
      position: relative;
      padding-top: 50px;
      z-index: 10;
    }
    .attention-title{
      width: 100%;
      img{
        width: 100%;
      }
    }
    .sub-title{
      margin-top: 8px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      span{
        box-sizing: border-box;
        width: 2.38rem;
        height: .24rem;
        color: #FFF;
        padding-left: 24px;
        font-size: 13px;
        display: flex;
        align-items: center;
        background: linear-gradient(270deg,rgba(74,99,246,0) 0%,rgba(74,99,246,1) 100%);
        border-radius: 18px;
        transform: translateX(30rpx);
      }
    }
    .teacher-list{
      position: relative;
      margin-top: 26px;
      padding: 12px;
      background: linear-gradient(180deg,rgba(59,88,229,1) 0%,rgba(40,71,222,1) 100%);
      border-radius: 8px;
      box-shadow: 0px 4px 24px 0px rgba(255,255,255,0.2);
      z-index: 10;
      margin-bottom: 166px;
    }
    .flowing-star1{
      position: absolute;
      top: -46px;
      left: 0;
      width: 86px;
      img{
        width: 100%;
      }
    }
    .flowing-star2{
      position: absolute;
      top: 50%;
      right: -15px;
      width: 31px;
      height: 124px;
    }
    .teacher-item{
      position: relative;
      background: #FFF;
      box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.08);
      margin-bottom: 8px;
      border-radius: 8px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      min-height: 88px;
      &.teacher-item:last-child{
        margin-bottom: 0;
      }
      .avatar{
        margin-left: 16px;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        overflow: hidden;
        flex-shrink: 0;
        img{
          width: 100%;
        }
      }
      .info{
        margin-left: 12px;
        .name{
          font-size: 14px;
          line-height: 14px;
          font-weight: bold;
          color: #333;
        }
        .title-box{
          margin-top: 5px;
          font-size: 12px;
          line-height: 18px;
          color: #999;
          .teacher-title{
            max-width: 2rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .link-arrow{
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        font-size: 14px;
        color: #CACACA;
      }
    }
  }
</style>

<script>
  export default {
    data() {
      return {
        dataDone: false,
        // 老师列表
        teacherList: [],
      }
    },
    created() {
      this.$root.post('/Lecturer/get_recently_online_teacher').then(data => {
        console.log(data);
        this.dataDone = true;
        this.teacherList = data;
      })
    },
    methods: {
      toTeacherDetail(id) {
        this.$router.push({name: 'LecturerDetail', params: {id: id}});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Lecturer/recommend.vue